export default "__VITE_ASSET__DhEgmMb8__"